import { render } from "./PatientDatatableAdvanceActions.vue?vue&type=template&id=8834700c"
import script from "./PatientDatatableAdvanceActions.vue?vue&type=script&lang=js"
export * from "./PatientDatatableAdvanceActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__